import React, { useEffect, useRef } from "react";
import clock from '../assets/images/clock.svg'

import lightGreenArrowOutline from '../assets/images/light-outline-arrow.svg'
import { useNavigate } from "react-router-dom";

import axios from "axios";
import IP from "../variable";

import { useQuery } from "react-query";
import useAxios from "../utils/useAxios";
import { formatTime } from "../utils/formatTime";


const CompanyMeetings = () => {

    const navigate = useNavigate()

    let api = useAxios()

    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        "all-meetings",
        async () => api.get(`${IP}/company/meetings`),
        { cacheTime: 0 }
    );

    const slots = data?.data?.meetings ?? []

    console.log(slots)

    return (
        <>
            <div className="table-header">
                Meeting Slots
            </div>

            {
                isLoading ?

                    <div className="placeholder-wave">
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                    </div>
                    :

                    slots.length > 0 ?

                    slots.map((slot) => (

                        <div key={slot.id} className="custom-card">
                            <div className="d-flex flex-column">
                            <span>
                                {slot?.name}
                            </span>
                            <span className="highlight" style={{fontSize: '0.7rem'}}>
                                {formatTime(slot?.start_time)} - {formatTime(slot?.end_time)}
                            </span>
                            </div>
                            <span>
                                <span className="d-flex align-items-center">
                                    <span className="d-flex align-items-center">
                                        <p style={{marginBottom: '0', fontSize: '1.5rem', marginRight: '5px'}}>
                                            {slot?.registration_count}/4
                                        </p>
                                            
                                            <p style={{'fontSize': "0.7rem", marginBottom: 0, display: 'flex', flexDirection: 'column'}}>
                                                <span> {slot.registration_count !== 1 ? 'Investors': 'Investor'} </span>
                                                <span style={{marginTop: "-5px"}} >Registered</span>
                                            </p>
                                        </span>
                                    <img
                                        onClick={() => navigate(`/company/slot/${slot?.id}`)}
                                        className="enter-arrow"
                                        src={lightGreenArrowOutline}
                                        alt=""
                                    />
                                </span>
                            </span>
                        </div>
                    ))
                    :

                    <div className="text-center">
                        <p>No Records Found</p>
                    </div>

            }
        </>
    )
}


export default CompanyMeetings;